<template>
    <div @click="restart()">
        <template v-if="currentTxt != ''">
            <div :class="typingClass" v-html="currentTxt"></div>
        </template>
        <template v-else>
            <v-row v-if="title==true">
                <v-col cols="12" class="b">
                    <v-tooltip top color="green">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-large fab color="green" class="d-none d-sm-inline hover:yellow" 
                                v-bind="attrs"
                                v-on="on"
                                @click="restart()">
                                <v-icon>mdi-play</v-icon>
                            </v-btn>
                        </template>
                        <span>Lire la suite</span>
                    </v-tooltip><v-icon large color="yellow darken-2" class="mt-5 pl-3">mdi-arrow-down-right</v-icon>
                </v-col>
                <v-col cols="12">
                    <v-skeleton-loader
                        elevation="2"
                        type="article" title="Prêt à lire la suite"
                        color="red" class="typing"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
        </template>
    </div>
  </template>
  
  <script>


  export default {
    name: 'TypingTxt',
    props: ['classes', 'title', 'desc', 'txtInx', 'sectionInx', 'onetimeonly'],
    data: () => ({
        currentTxtInx: 0,
        currentTxt : "",
        timeout: null,
        txtInxLo: 0,
        allTxt: '',
        restarted: false,
        txtString: ""
    }),
    mounted() {
        //this.startTyping()
        this.txtInxLo = (this.sectionInx * 10) + this.txtInx
        this.txtString = this.getTxt()

        this.currentTxtInx = 0

        this.$root.$on('startNextTyping', (newTxtInx) => { 

            //console.log("startNextTyping", this.txtInxLo, newTxtInx, (this.txtInxLo > newTxtInx))
            if(this.txtInxLo == newTxtInx){
                console.log("startNextTyping", this.onetimeonly, this.restarted)
                if(this.onetimeonly===true && this.restarted) return
                this.restarted = true
                console.log("startNextTyping2", this.txtInxLo, newTxtInx, this.onetimeonly, this.restarted)
                this.currentTxtInx = 0
                this.startTyping()
            }
            else if(this.txtInxLo > newTxtInx){
                clearTimeout(this.timeout)
                if(this.onetimeonly===true && this.restarted) return
                this.currentTxtInx = 0
                this.currentTxt = ""
            }
            else if(this.txtInxLo < newTxtInx){
                //clearTimeout(this.timeout)
                //console.log("this.txtInxLo", this.txtInxLo)
                //if(this.currentTxt == "") this.incTyping()
                setTimeout(()=> { 
                    clearTimeout(this.timeout) 
                    this.currentTxtInx = this.allTxt.length 
                    this.currentTxt = this.allTxt
                }, 10)
                //this.startTyping()
            }
        })
    },
    beforeDestroy() {
        this.$root.$off('startNextTyping', 0)
        clearTimeout(this.timeout)
    },
    methods: {

        restart() {

            clearTimeout(this.timeout)
            console.log("restart", this.txtInxLo)
            this.$root.$emit("startNextTyping", this.txtInxLo)
            this.currentTxtInx = 0
            this.currentTxt = ""
            //this.startTyping()
        },
        startTyping() { 
            let randTimeout = parseInt(Math.random() * 100)
            //console.log("incTyping randTimeout", randTimeout)
            this.timeout = setTimeout(()=>{ this.incTyping() }, randTimeout)
        },
        incTyping() {
            //if(this.currentTxtInx == 0) return
            //reconstitue toute la chaine html du slot dans une seule string
            let txt = this.txtString
            
            //fait avancer le curseur
            this.currentTxtInx++

            //ajoute les balise en entier
            if(txt.charAt(this.currentTxtInx) == "<"){
                while(txt.charAt(this.currentTxtInx) != ">"){
                    this.currentTxtInx++
                }
            }

            this.allTxt = txt
            this.currentTxt = txt.substring(0, this.currentTxtInx) + (this.currentTxtInx < txt.length ? " |" : "")

            //console.log("incTyping", this.currentTxtInx, this.currentTxt, txt, this.$slots)
            if(this.currentTxtInx < txt.length) 
                this.startTyping()
            else{
                console.log("incTyping before startNextTyping", this.txtInxLo)
                this.$root.$emit("startNextTyping", this.txtInxLo + 1)
            }
        },
        getTxt(){
            let txt = ""
            this.$slots.default.forEach((slot)=>{
                //console.log("slot", slot)
                if(slot.tag != null){ 
                    if(slot.children != null){
                        txt += "<" + slot.tag
                        // console.log("data", slot.data)
                        if(slot.data != null)
                        Object.keys(slot.data).forEach(key => {
                            //console.log("data", key, slot.data[key]);
                            let k = key
                            if(key == 'staticClass') k = 'class'
                            txt += " " + k + '="' + slot.data[key] + '"'
                        })
                        txt += ">"
                        slot.children.forEach((child)=>{
                            txt += child.text
                        })
                        txt += "</" + slot.tag + ">"
                    }else{
                        txt += "<" + slot.tag + ">"
                    }
                }
                else if(slot.text != null) txt += slot.text
            })
            return txt
        }
    },
    computed: {
        typingClass() {
            let classes = "typing"
            if(this.title === true) classes += " title"
            if(this.desc === true) classes += " desc"
            return classes
        },
    }
  }
  </script>
  
  <style lang="scss">
  </style>